var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-dice-component-dice",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.model.body)}})}
var staticRenderFns = []

export { render, staticRenderFns }